import { getConfig } from '../services/server-url-config/env';
import enUS from './en-US.json';
import zhCN from './zh-CN.json';
import koKR from './ko-KR.json';
import jaJP from './ja-JP.json';
import zhTW from './zh-TW.json';
import plPL from './pl-PL.json';
import { getLocale, setLocale, StandardLocale, handleUrlLocale, PlatformType } from 'src/gs-utils/core/storage/LocaleManager';

export const initI18n = () => {
  handleUrlLocale(PlatformType.ALL);
  // locale的存储必须和主应用保持一致
  let locale = getLocale();
  setLocale(locale);
  // 语言包放本地
  const localeMap = {
    [StandardLocale.ZH_CN]: zhCN,
    [StandardLocale.EN_US]: enUS,
    [StandardLocale.KO_KR]: koKR,
    [StandardLocale.JA_JP]: jaJP,
    [StandardLocale.ZH_TW]: zhTW,
    [StandardLocale.PL_PL]: plPL
  };
  window.appLocale = localeMap[locale] || enUS;
};

export const i18n = (key, parameter) => {
  if (!key) {
    console.error('i18n key is required', key);
    return '';
  }
  try {
    let value = window.appLocale;
    value = value[key];
    if (!value) {
      // const urlConfig = getConfig();
      // 测试环境增加多语言toast排查，仅在触发兜底的时候触发
      // if (urlConfig.env === 'test') {
      //   alert(`i18n_missingKeys: ${key}`);
      // }
      return key;
    }
    if (typeof parameter == 'string' || typeof parameter == 'number') {
      value = value.replace(/%s/g, parameter);
    } else if (typeof parameter == 'object') {
      for (let k in parameter) {
        if (typeof parameter[k] == 'string' || typeof parameter[k] == 'number') {
          value = value.replace(new RegExp(`{{${k}}}`, 'g'), parameter[k]);
        }
      }
    }
    return value;
  } catch (err) {
    return key;
  }
};
